import { render, staticRenderFns } from "./relation_mention_tag.vue?vue&type=template&id=4a75770e"
import script from "./relation_mention_tag.vue?vue&type=script&lang=js"
export * from "./relation_mention_tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports